__turbopack_context__.v({
  "root": "YDDkuW_root",
});
